/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';
import styled from 'styled-components';

export default function BrandIcon() {
  return (
    <BrandContainer>
      {/* <TextRed>IP</TextRed> */}
     
      <TextBlue>
        <strong>Authorized <br />Marketing</strong><br /> 
      <TextRed><strong>Partners </strong></TextRed>
      </TextBlue>
      
    </BrandContainer>
  );
}

const BrandContainer = styled.p`
  display: flex;
  align-items: center;
  margin-top: 10px;
  font-size: 1rem;
  font-family: "Lato", sans-serif;
  font-weight: 800;
`;

const TextRed = styled.span`
  color: #ffffff; 
  font-weight: 800;
`;

const TextBlue = styled.span`
color: #fff;
`;

